module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-746-retro-min.782a81d7.jpg";